import React, { createContext } from 'react';

import {
  ECookieProcessingServices,
  TCookieProcessingServices,
} from '~/constants/cmp';
import useCookieConsents from '~/hooks/useCookieConsents';
import { useCookiePopupLanguage } from '~/hooks/useCookiePopupLanguage';

export const CookieConsentsContext = createContext<{
  consents: Partial<TCookieProcessingServices>;
  acceptService: (service: ECookieProcessingServices) => Promise<void>;
}>({
  consents: {},
  acceptService: async () => {},
});

const CookieConsentsProvider: React.FC = ({ children }) => {
  const value = useCookieConsents();
  useCookiePopupLanguage();

  return (
    <CookieConsentsContext.Provider value={value}>
      {children}
    </CookieConsentsContext.Provider>
  );
};

export default CookieConsentsProvider;
